import { httpRequest } from '@/services/http'

const _getProducts = async () => {
  const response = await httpRequest({
    url: '/products',
    options: { method: 'GET' }
  })

  if (response.error) return response

  return response
}

export default {
  get: _getProducts
}
